export default "__VITE_ASSET__DbK8ILDB__"